// フォールバック（127.0.0.1）を削除し、環境変数を優先させる
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const R2_DOMAIN = import.meta.env.VITE_R2_DOMAIN || "";

console.log("[DEBUG] API_BASE_URL:", API_BASE_URL);

if (!API_BASE_URL) {
  console.warn("WARNING: VITE_API_BASE_URL is not defined!");
}

export async function fetchFromApi(path: string, options?: RequestInit) {
  // URL が未定義の場合は相対パスとして扱うか、エラーを防ぐ
  const baseUrl = API_BASE_URL || "";
  const url = path.startsWith("http") ? path : `${baseUrl}${path}`;
  
  const response = await fetch(url, options);
  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody.error || `API error: ${response.status} ${response.statusText}`);
  }
  return response.json();
}

export const apiClient = {
  get: (path: string) => fetchFromApi(path),
  post: (path: string, body: any) => fetchFromApi(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  }),
  patch: (path: string, body: any) => fetchFromApi(path, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  }),
  delete: (path: string) => fetchFromApi(path, {
    method: 'DELETE'
  }),
  upload: (path: string, formData: FormData) => fetchFromApi(path, {
    method: 'POST',
    body: formData
  })
};

export function getImageUrl(id: string) {
  return `${API_BASE_URL}/images/${id}`;
}

export function getStorageUrl(bucket: string, path: string) {
  return `${API_BASE_URL}/storage/${bucket}/${path}`;
}
